<template>
  <div class="lby-chart">
    <div class="lby-header">
      <img :src="logo"/>
      <div class="overflow-ellipsis">尊敬的{{user?"用户":userInfo.userName}}，您好!</div>
    </div>
    <div class="lby-login-register" v-if="user">
        <div @click="login">立即登录</div>
        <div @click="register">立即注册</div>
    </div>
    <div class="lby-login-register" v-else>
        <div @click="usercenter">个人中心</div>
        <div @click="logout">退出登录</div>
    </div>
    <div style="margin-top:30px;font-size: 20px;">
      <CallAgent></CallAgent>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
export default {
  name: 'LoginComponent',
  data () {
    return {
      logo
    }
  },
  methods: {
    usercenter () {
      this.$router.push({ path: '/usercenter' })
    },
    gamecenterClick () {
      console.log('xxx')
    },
    login () {
      this.$router.push({
        path: '/login',
        query: {
          backUrl: '/',
          type: 'false'
        }
      })
    },
    register () {
      this.$router.push({
        path: '/login',
        query: {
          backUrl: '/',
          type: 'true'
        }
      })
    },
    logout () {
      this.$messageBox.confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout')
        this.$message({
          type: 'success',
          message: '退出登录!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user.authorization == null
    },
    userInfo () {
      return this.$store.state.user.user
    }
  }
}
</script>

<style scoped lang="less">
.lby-chart{
    width: 250px;
    height: 350px;
    margin-left: 16px;
    border-radius: 10px;
    border: 1px solid rgb(134, 134, 134);
    background: linear-gradient(to right, #b570b5, #f4ce30);
    box-shadow: 0 0 2px #d3d3d3;
    color:white;
    .lby-header{
      margin:20px auto;
      height: 100px;
      margin-top: 30px;
      div{
        height: 48px;
        line-height: 48px;
        font-size: 17px;
        color: rgb(255, 255, 255);
      }
    }
    .lby-login-register{
      margin:0 auto;
      div{
        width: 130px;
        height: 40px;
        background-color: rgb(14, 93, 161);
        text-align: center;
        line-height: 40px;
        border-radius: 10px;
        margin: 10px auto;
        cursor: pointer;
      }
      div:hover{
        width: 135px;
        background-color: rgb(40, 132, 212);
        font-size: 15px;
      }
    }
    .lby-footer{
      img{
        cursor: pointer;
      }
    }
}
</style>
